import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  display: flex;
`;

export const CardsWrap = styled.div`
  flex: 1;
`;

export const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 22px;
`;

export const Card = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const DetailsWrap = styled.div`
  ${({ theme }) => `
    padding: 0 10px;

    @media ${minBp('tablet')} {
      display: flex;
      padding: 0;
      flex: 1;
    }
  `}
`;

export const PriceTimeWrap = styled.div`
  display: flex;
`;

export const ImageWrap = styled.div``;

export const ImageOuter = styled.div`
  width: 60px;
  height: 46px;
  border: 1px solid #d4d3d1;
  background-color: white;

  @media ${minBp('tablet')} {
    width: 90px;
    height: 70px;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Name = styled.div`
  flex: 1;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-weight: 500;
  text-transform: uppercase;
  color: black;
  margin-bottom: 8px;

  @media ${minBp('tablet')} {
    font-size: 17px;
    padding: 0 15px;
    min-height: 50px;
    display: flex;
    align-items: center;
    margin: 0;
  }
`;

export const Price = styled.div`
  width: 60px;
  font-size: 12px;

  @media ${minBp('tablet')} {
    min-height: 50px;
    border-left: 1px solid #ccc;
    padding: 0 15px;
    display: flex;
    align-items: center;
    width: 100px;
    font-size: 14px;
  }
`;

export const FittingTime = styled.div`
  width: 65px;
  border-left: 1px solid #ccc;
  padding-left: 10px;
  font-size: 12px;

  @media ${minBp('tablet')} {
    width: 100px;
    padding: 0 15px;
    min-height: 50px;
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  svg {
    width: 9px;
    height: 9px;
    vertical-align: middle;

    @media ${minBp('tablet')} {
      width: 13px;
      height: 13px;
      margin-right: 5px;
    }

    path {
      fill: #5e6065;
    }
  }
`;

export const Button = styled.button`
  ${({ active }) => `
    min-width: 75px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    color: ${active ? 'white' : 'black'};
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    appearance: none;
    background: ${active ? 'black' : 'transparent'};
    line-height: 1;
    margin-left: 5px;
    padding-top: 4px;

    ${
      !active
        ? `
      &:focus {
        background-color: #ccc;
      }
    `
        : ``
    }

    @media ${minBp('tablet')} {
      min-width: 90px;
    }
  `}
`;
